import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { totalViewsConfig } from '@/lib/analytics/kpis/youtube/totalViews';
import { SIZE_50 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerViewsConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> = {
    ...totalViewsConfig,
    id: 'views',
    name: 'kpi.youtube.mediaviewer.views',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
